import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className:
    'mx-auto flex flex w-full flex-col flex-col items-start gap-16 overflow-hidden rounded-[3px] bg-decorative-ev-subtle p-16'
});

export const CleanVehicleTaxPill = createComponent('div', {
  className:
    'w-fit rounded-full bg-decorative-ev px-8 py-[2px] text-blue-6 tl-header-xs'
});

export const Bold = createComponent('span', { className: 'font-bold' });
